var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,13.5H10c-0.2-0.9-1-1.6-2-1.6s-1.8,0.7-2,1.6H0.5C0.2,13.5,0,13.7,0,14s0.2,0.5,0.5,0.5H6 C6.2,15.3,7,16,8,16s1.8-0.7,2-1.6h5.5c0.3,0,0.5-0.2,0.5-0.5S15.8,13.5,15.5,13.5z M8,15c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1 s1.1,0.5,1.1,1.1S8.6,15,8,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,2.5h2.7c0.2,0.9,1,1.6,2,1.6s1.8-0.7,2-1.6h8.4C15.8,2.5,16,2.3,16,2s-0.2-0.5-0.5-0.5H7.1 C6.9,0.7,6.1,0,5.1,0s-1.8,0.7-2,1.6H0.5C0.2,1.6,0,1.8,0,2S0.2,2.5,0.5,2.5z M5.1,1C5.7,1,6.2,1.5,6.2,2S5.7,3.1,5.1,3.1 S4.1,2.6,4.1,2S4.6,1,5.1,1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,7.5h-2.4c-0.2-0.9-1-1.6-2-1.6s-1.8,0.7-2,1.6H0.5C0.2,7.5,0,7.7,0,8s0.2,0.5,0.5,0.5h8.6 c0.2,0.9,1,1.6,2,1.6s1.8-0.7,2-1.6h2.4C15.8,8.5,16,8.3,16,8S15.8,7.5,15.5,7.5z M11.1,9.1C10.5,9.1,10,8.6,10,8s0.5-1.1,1.1-1.1 c0.6,0,1.1,0.5,1.1,1.1S11.7,9.1,11.1,9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9948c127fe91c8dcb5ffa285cb0b859a.svg";
export { ForwardRef as ReactComponent };